<template>
  <div class="tx-glossar glossar__list -max-width-limited">
    <div class="list__input -decrease-width">
      <div class="search__input">
        <input id="glossar-search" :class="inputStatus ? '-filled' : ''" @keyup="getGlossar" v-model="inputSearch">
        <div class="input__background">
          <label for="glossar-search" class="control__label">{{ inputPlaceholder }}</label>
        </div>
      </div>
      <button v-show="!inputStatus" @click="getGlossar" aria-label="search">
        <span class="icon-search-before"></span>
      </button>
      <button v-show="inputStatus" @click="clearInput" aria-label="search">
        <span class="icon-close-before"></span>
      </button>
    </div>
    <div class="list__wrapper-letters">
      <div class="list__letters">
        <div class="swiper" ref="swiper">
          <div class="swiper-wrapper">
            <div @click="scrollTo(letter)" v-for="(letter, index) in letters" :key="index" :class="[letter === activeLetter ? '-active' : '']" class="letters__letter swiper-slide">
              {{ letter }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="list__list list__list-loading">
      <div v-for="item in 4" :key="`loading-${item}`" class="list__element">
        <span class="element__title"></span>
        <div class="item__link line line-one"></div>
        <div class="item__link line line-two"></div>
        <div class="item__link line line-three"></div>
        <div class="item__link line line-four"></div>
      </div>
    </div>
    <div v-else class="list__list">
      <div v-for="(items, key) in glossar" :key="items.id" :id="key" class="list__element">
        <span class="heading epsilon">{{ key }}</span>
        <div v-for="link in items" :key="link.id" class="item__link">
          <a :href="link.link" class="icon-angle-right-before">{{ link.title }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import Swiper from 'swiper'

export default {
  name: 'App',
  components: {},
  data() {
    return {
      swiper: null,
      glossar: [],
      glossarApiError: '',
      apiBase: window.app.glossar_list.api_base,
      glossarType: window.app.glossar_list.glossar_type,
      inputPlaceholder: window.app.glossar_list.input_placeholder,
      inputSearch: '',
      currentLocale: window.app.glossar_list.locale,
      activeLetter: '',
      inputStatus: false,
      loading: false
    }
  },
  computed: {
    letters() {
      return Array.from(Array(26)).map((event, charCode) => String.fromCharCode(charCode + 65)).filter(letter => this.glossar[letter])
    }
  },
  methods: {
    getGlossar()
    {
      this.loading = true
      let config = {}
      if (this.inputSearch !== '')
      {
        let search = this.inputSearch
        search = search.replace('ae', '_')
        search = search.replace('oe', '_')
        search = search.replace('ue', '_')
        search = search.replace('a', '_')
        search = search.replace('o', '_')
        search = search.replace('u', '_')
        config = {
            params: {
                title: {
                    like: `%${search}%`
                }
            }
        }
      }
      Axios.get(this.apiBase + this.glossarType, config)
        .then((response) =>
        {
          this.glossar = response.data.reduce((acc, obj) => {
            let key = obj.title[0].toLocaleUpperCase()
            if (key === 'Ä') {
              key = 'A'
            } else if (key === 'Ö') {
              key = 'O'
            } else if (key === 'Ü') {
              key = 'U'
            }
            const curGroup = acc[key] ?? []
            return { ...acc, [key]: [...curGroup, obj] }
          }, {})
          this.checkFillInput()
          // Update search query
          const url =  new URL(window.location.href)
          url.searchParams.set('search', this.inputSearch)
          window.history.pushState({}, '', url)
          this.$nextTick(() => {
            this.swiper.update()
          })
          this.loading = false
        })
        .catch((error) =>
        {
          this.glossarApiError = error.message
        })
    },
    scrollTo(letter)
    {
      if (document.getElementById(letter)) {
        gsap.to(window, { duration: 0.5, scrollTo: { y:`#${letter}`, offsetY: 70 } })
      }
    },
    fixedLetters()
    {
      const letters = document.querySelector('.tx-glossar .list__wrapper-letters')
      if (letters.getBoundingClientRect().top > 0 ) {
        document.querySelector('.tx-glossar .list__letters').classList.remove('-fixed')
      }
      if (letters.getBoundingClientRect().top <= 0 ) {
        document.querySelector('.tx-glossar .list__letters').classList.add('-fixed')
      }
    },
    isInViewport(element)
    {
      const position = element.getBoundingClientRect()
      return (
        position.top + element.offsetHeight - 70 >= 0 &&
        position.left >= 0 &&
        position.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        position.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    },
    setActiveLetter()
    {
      let listElements = document.querySelectorAll('.tx-glossar .list__element')
      let activeLetter = 'A'
      for (let i = 0; i < listElements.length; i++) {
        if (this.isInViewport(listElements[i])) {
          activeLetter = listElements[i].innerText[0].toLocaleUpperCase()
          break
        }
      }
      this.activeLetter = activeLetter
    },
    checkFillInput()
    {
      this.inputStatus = !!document.querySelector('.tx-glossar .search__input input').value;
    },
    clearInput()
    {
      this.inputSearch = ''
      this.getGlossar()
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollToPlugin)

    const url = new URL(window.location.href)
    if (url.searchParams.has('search')) {
      this.inputSearch = url.searchParams.get('search')
    } else {
      url.searchParams.set('search', this.inputSearch)
    }
    this.swiper = new Swiper(this.$refs.swiper,
      {
        slidesPerView: 'auto',
        grabCursor: true,
        watchOverflow: true
      }
    )
    this.getGlossar()
    this.scrollTo()
    this.setActiveLetter()
    this.checkFillInput()
    window.addEventListener('scroll', this.fixedLetters)
    window.addEventListener('scroll', this.setActiveLetter)
  }
}
</script>
